
import { Options, Vue } from "vue-class-component";
import CustomDrowpdown from "@/app/ui/components/custom-dropdown/index.vue";
import RadioButton from "primevue/radiobutton";
import { AccountController } from "@/app/ui/controllers/AccountController";
import {
  formatInputByCountry,
  parseByCountry
} from "@/app/infrastructures/misc/Utils";

@Options({
  emits: ["change", "update:modelValue", "update:discountValue"],
  components: {
    CustomDrowpdown,
    RadioButton
  },
  props: {
    placeholder: {
      default: "Pilih",
      type: String
    },
    modelValue: {
      default: {},
      required: true
    },
    discountValue: {
      default: 0,
      requires: true
    }
  }
})
class DiscountDropdown extends Vue {
  props: any = this.$props;

  dropdownDiscountOpened = true;

  get countryCode() {
    const code = AccountController.accountData?.countryCode;
    return code?.toUpperCase() ?? "ID";
  }

  get selectedValue() {
    if (this.radioValue === "Default") {
      return [{ name: "Default", discount: 0 }];
    } else {
      return [
        {
          name: "Custom",
          discount: this.props.modelValue.discount
        }
      ];
    }
  }

  get parseDefaultValue() {
    return this.props.modelValue.find(
      (item: any) => item.name.toLowerCase() === "default"
    )
      ? "Default"
      : "Custom";
  }
  get watchModelValue() {
    this.radioValue =
      this.props.modelValue.length > 0 ? this.parseDefaultValue : "Custom";
    return "";
  }

  formatDefaultDiscount(val: string) {
    return formatInputByCountry(val, {
      type: "percentage",
      country: this.countryCode
    });
  }

  get parsedDefaultDisount(){
    return parseByCountry(this.props.discountValue, {
      country: this.countryCode
    });
  }
  //radio
  radioValue = "";

  onChange() {
    this.$emit("change", this.selectedValue);
    this.$emit("update:modelValue", this.selectedValue);
  }

  onChangeValueDiscount(e: any) {
    this.$emit("change", e);
    this.$emit("update:discountValue", e);
  }
}
export default DiscountDropdown;
